<script lang="ts"></script>

<div class="context-menu-separator"></div>

<style lang="scss">
  .context-menu-separator {
    background-color: var(--context-menu-border);
    height: 1px;
  }
</style>
